export const MuiInputBase = {
  styleOverrides: {
    root: { fontSize: "1.6rem" },
  },
}
